import React from "react";
import { PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { ChartDataItem } from "../../types/dashboard";
interface ChartContainerProps {
  hasValidData: boolean;
  chartData: ChartDataItem[];
  renderCustomizedLabel: (props: any) => React.ReactNode;
  CustomTooltip: React.ComponentType<any>;
}

const ChartContainer: React.FC<ChartContainerProps> = ({ hasValidData, chartData, renderCustomizedLabel, CustomTooltip }) => {
  // Enhanced cell rendering with better visual effects
  const renderCells = () => {
    return chartData.map((entry, index) => (
      <Cell
        key={`cell-${index}`}
        fill={entry.color}
        stroke="#ffffff"
        strokeWidth={3}
        strokeOpacity={0.9}
        opacity={!hasValidData ? 0.3 : 1}
        className="transition-all duration-500 ease-out hover:opacity-90 hover:scale-105"
        style={{
          filter: hasValidData ? `drop-shadow(0 4px 8px ${entry.color}40)` : "none",
        }}
      />
    ));
  };

  return (
    <div className="relative w-full h-full">
      {/* Enhanced background effects */}
      <div className="absolute inset-0 flex items-center justify-center">
        {!hasValidData && <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-50 rounded-full opacity-60"></div>}
        <div className="absolute w-32 h-32 bg-blue-500/5 rounded-full blur-xl"></div>
      </div>

      <ResponsiveContainer width="100%" height="100%">
        <RechartsPieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={hasValidData ? 100 : 80}
            innerRadius={hasValidData ? 60 : 40}
            paddingAngle={hasValidData ? 2 : 0}
            dataKey="value"
            animationDuration={200}
            startAngle={90}
            endAngle={450}
            className="transition-all duration-700 ease-out"
          >
            {renderCells()}
          </Pie>
          {hasValidData && <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(255, 255, 255, 0.1)" }} />}
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartContainer;
